/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type AssetResponseAssetType =
    (typeof AssetResponseAssetType)[keyof typeof AssetResponseAssetType];

export const AssetResponseAssetType = {
    BATTERY: 'BATTERY',
    DRONE: 'DRONE'
} as const;
